"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSetupWidget = void 0;
var _widgetActions = require("../../store/widget/widgetActions");
var _react = require("react");
var _widgetSelectors = require("../../store/widget/widgetSelectors");
var _questionnaireActions = require("../../store/questionnaire/questionnaireActions");
var _productCatalogSelectors = require("../../store/productCatalog/productCatalogSelectors");
var _productCatalogActions = require("../../store/productCatalog/productCatalogActions");
var _productCatalogUtil = require("../../utils/productCatalogUtil");
var _questionnaireUtil = require("../../utils/questionnaireUtil");
var _userActions = require("../../store/user/userActions");
var _services = require("../../services");
var _useAppDispatch = require("../useAppDispatch");
var _useAppSelector = require("../useAppSelector");
const useSetupWidget = instanceId => {
  const dispatch = (0, _useAppDispatch.useAppDispatch)();
  const questions = (0, _useAppSelector.useAppSelector)(_widgetSelectors.selectConfigQuestions);
  const market = (0, _useAppSelector.useAppSelector)(_widgetSelectors.selectConfigMarket);
  const handsets = (0, _useAppSelector.useAppSelector)(_productCatalogSelectors.selectHandsets);
  const lowestPlanPrice = (0, _useAppSelector.useAppSelector)(_productCatalogSelectors.selectLowestPlanPrice);
  const isWidgetLoaded = (0, _useAppSelector.useAppSelector)(_widgetSelectors.selectIsWidgetLoaded);
  const isWidgetReady = (0, _useAppSelector.useAppSelector)(_widgetSelectors.selectIsWidgetReady);
  (0, _react.useEffect)(() => {
    if (!isWidgetLoaded) {
      dispatch((0, _widgetActions.setInstanceId)(instanceId));
      dispatch((0, _userActions.fetchUserSessionByMarketingId)(_services.Services.host.marketingId));
      dispatch((0, _widgetActions.setWidgetLoadedStatus)(true));
    }
  }, [isWidgetLoaded]);
  (0, _react.useEffect)(() => {
    if ((handsets === null || handsets === void 0 ? void 0 : handsets.length) > 0) {
      const handsetList = (0, _productCatalogUtil.getProductCatalogHandsetList)(handsets);
      const brandListName = (0, _productCatalogUtil.getProductCatalogBrandNameList)(handsets);
      (0, _questionnaireUtil.filterBrandQuestionChoices)(questions, brandListName);
      dispatch((0, _questionnaireActions.setQuestions)((0, _questionnaireUtil.translateQuestions)(questions, market)));
      dispatch((0, _questionnaireActions.setHandsetSearchList)(handsetList));
    }
  }, [handsets]);
  (0, _react.useEffect)(() => {
    if ((questions === null || questions === void 0 ? void 0 : questions.length) > 0 && !isWidgetReady) {
      dispatch((0, _questionnaireActions.setQuestions)((0, _questionnaireUtil.translateQuestions)(questions, market)));
      if ((0, _questionnaireUtil.hasHandsetFlow)(questions)) {
        dispatch((0, _productCatalogActions.fetchHandsets)());
      }
      dispatch((0, _widgetActions.setWidgetReadyStatus)(true));
    }
  }, [questions, isWidgetReady]);
  (0, _react.useEffect)(() => {
    if ((questions === null || questions === void 0 ? void 0 : questions.length) > 0 && !isWidgetReady && !lowestPlanPrice && market === 'cl' && (0, _questionnaireUtil.hasPlanFlow)(questions)) {
      dispatch((0, _productCatalogActions.fetchLowestPlanPrice)());
    }
  }, [questions, isWidgetReady]);
  (0, _react.useEffect)(() => {
    if (isWidgetReady) {
      window.dispatchEvent(new Event('gsAppReady'));
    }
  }, [isWidgetReady]);
};
exports.useSetupWidget = useSetupWidget;